export const COMPLETED = "completed";
export const PENDING = "pending";
export const FAILED = "failed";
export const MAX_JOB_COUNT = 8;
export const EXPORT_STATUSES = [PENDING, COMPLETED, FAILED].map((s) => ({
  id: s,
  name: s,
}));
